module.exports = __webpack_public_path__ + "static/Smule-9be2d7093a7a5dbbf9784f28a97cb4fe.jpg";